<script>

import userService from '../../services/user.js'

export default {
    name: 'users-office',
    props : ['users'],
    data() {
       return {
          header: [
              {
                 title: 'Nome',
                 alias:'nome'
              },
              {
                 title:'Login',
                 alias:'login'
              },
              {
                 title: 'Email',
                 alias: 'email'
              },
              {
                 title:'Ativo',
                 alias:'ativo'
              },
              {
                title:'Opções',
                alias:'opcoes'
              }
          ],
       }
    },
    computed : {
        actives() {
            return this.users.filter( (v) => { return v.ativo } ).length;
        }
    },
    methods : {
        reset(login){
            userService.resetPassword(login)
            .then(response => {
                if (!response.data.erro) {
                    this.showNewPass(response.data.novaSenha)
                } else {
                    alert("Erro ao resetar a senha: " + response.data.mensagem)
                }
            }, err => {
                console.log(err);
            })
        },
        confirmReset(_user) {
            this.$bus.$emit("confirModal", {
                confirmOnly: false,
                title: _user.nome,
                message: `<b>Deseja gerar uma nova senha para este usuário?</b></br></br>
                Após alterá-la, o usuário somente terá acesso ao sistema com a nova senha que for gerada`,
                responseKey: "resetPassword",
                anyData : {
                    login : _user.login
                }
            });
        },
        showNewPass(pass) {
            this.$bus.$emit("confirModal", {
                confirmOnly: true,
                title: "Nova senha gerada com sucesso",
                message: 'Anote a nova senha gerada para este usuário <b>' + pass + '</b>',
                responseKey: "showNewPass",
            });
        },

        activate(login, active){
            userService.activateUser(login, active)
            .then(response => {
                if (!response.data.erro) {
                    this.users.find( el => { return el.login == login }, login).ativo = active;
                } else {
                    alert("Erro ao executar a operação: " + response.data.mensagem)
                }
            }, err => {
                console.log(err);
            })
        },
        confirmActivate(_user) {
            //pode ativar até 5 usuárioss
            if (this.actives < 5 || _user.ativo) {
                let active = _user.ativo ? "desativar" : "ativar";
                let warning = _user.ativo ? "Esta ação impedirá que o usuário acesse o sistema, mas todos os cálculos realizados permanecerão salvos" : "";
                this.$bus.$emit("confirModal", {
                    confirmOnly: false,
                    title: _user.nome,
                    message: `<b>Deseja ${active} este usuário?</b></br>${warning}`,
                    responseKey: "activateUser",
                    anyData : {
                        login : _user.login,
                        active : !_user.ativo
                    }
                });
            } else {
                alert("Você já possui 5 usuários ativos");
            }
        },
    },

    created: function() {
        var that = this;
        this.$bus.$on('resetPassword', function(yes, data) {
            yes ? that.reset(data.login) : '';
        });
        this.$bus.$on("activateUser", function(yes, data) {
            yes ? that.activate(data.login, data.active) : '';
        });
    }
}
</script>

<template>
    <div class="p-table">
       <table class="table">
          <thead>
             <tr>
                <th v-for="e in header" @click="sort(e.alias)" scope="col">{{e.title}}</th>
             </tr>
          </thead>
          <tbody>
             <tr v-for="user in users">
                <td>{{ user.nome }}</td>
                <td>{{ user.login }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.ativo ? 'Sim' : 'Não' }}</td>
                <td>
                    <button class="btn btn-default btn-sm" @click.prevent="confirmActivate(user)" title="Ativar ou desativar usuário">
                        <font-awesome-icon icon="power-off" :class=" { 'activate' : !user.ativo, 'deactivate' : user.ativo}" />
                    </button>
                    <button class="btn btn-default btn-sm" @click.prevent="confirmReset(user)" title="Resetar a senha">
                        <font-awesome-icon icon="key" />
                    </button>
                </td>
             </tr>
             <tr >
                 <td class="counter" :colspan="header.length"><span>{{ actives }} usuários ativos</span></td>
             </tr>
         </tbody>
       </table>

    </div>
</template>

<style lang="scss">
    .table tr td {
        color : #727272 !important;

    }
    .counter {
        text-align: center;

        span {
            color : #5473ff !important;
        }
    }

    .activate {
        color : #459622;
    }
    .deactivate {
        color : #7f1e1e;
    }
</style>



// WEBPACK FOOTER //
// src/js/components/profile/p-users-office.vue